/* ============================================================
   Reviews carousel — prev/next arrows, scroll-snap, optional
   auto-advance. One card per view. Self-contained, no deps.
   ============================================================ */
(function () {
  function initRev(root) {
    var track = root.querySelector('.rev__track');
    if (!track) return;
    var cards = track.querySelectorAll('.rev__card');
    if (cards.length < 2) return;

    var prev = root.querySelector('.rev__arrow--prev');
    var next = root.querySelector('.rev__arrow--next');

    function maxScroll() { return track.scrollWidth - track.clientWidth; }

    // One card (+ gap) per step, so multi-card rows advance one at a time.
    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    // Advance by a card; loop back to the far end when we run off either side.
    function go(dir) {
      var max = maxScroll();
      if (dir > 0 && track.scrollLeft >= max - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && track.scrollLeft <= 2) {
        track.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    // Optional auto-advance; pauses on hover/focus/touch, loops back to start.
    if (root.getAttribute('data-autoplay') === 'true') {
      var interval = (parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
      var timer = null;
      var tick = function () { go(1); };
      var start = function () { stop(); timer = setInterval(tick, interval); };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      track.addEventListener('touchstart', stop, { passive: true });
      start();
    }
  }

  function boot() {
    document.querySelectorAll('.rev').forEach(initRev);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the section is added/edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.rev') : null;
    if (el) initRev(el);
  });
})();

